import React from "react";
import {SubcompanyDetailStats} from "./components/SubcompanyDetailStats";
import {SubcompanyDetailTable} from "./components/SubcompanyDetailTable";

export const SubcompanyDetailTotal = ({
    paymentTransactionsLogCalculation,
    tableData,
    tableLoading,
    pageParam,
    setPageParam,
    sharedLogFilters,
    fetchDetail
}) => {
    return (
        <div>
            <SubcompanyDetailStats data={paymentTransactionsLogCalculation?.data || {}} />
            <SubcompanyDetailTable
                data={tableData?.data}
                loading={tableLoading}
                subCompanyNames={paymentTransactionsLogCalculation?.data?.subCompanyNames}
                pageParam={pageParam}
                setPageParam={setPageParam}
                sharedLogFilters={sharedLogFilters}
                fetchDetail={fetchDetail}
            />
        </div>
    );
};
